import unhaImg from "@/assets/tratamento-unha-encravada-belem-para.jpg";
import calosImg from "@/assets/remocao-calos-calosidades-belem-para.jpg";
import diabImg from "@/assets/tratamento-pe-diabetico-belem-para.jpg";
import micoseImg from "@/assets/tratamento-micose-unhas-belem-para.jpg";
import hidratImg from "@/assets/hidratacao-pes-ressecados-belem-para.jpg";
import massagemImg from "@/assets/massagem-terapeutica-pes-belem-para.jpg";
import orteseImg from "@/assets/ortese-correcao-unhas-belem-para.jpg";
import verrugaImg from "@/assets/verrugas-plantares-belem-para.jpg";
import clinicaInterior from "@/assets/clinica-podologia-belem-para-interior.jpg";
import clinicaRecepcao from "@/assets/clinica-podologia-belem-recepcao.jpg";
import podologaImg from "@/assets/podologa-belem-para-rosa-chagas.jpg";

export type ServiceFaq = {
  q: string;
  a: string;
};

export type Service = {
  slug: string;
  title: string;
  shortTitle: string;
  
  excerpt: string;
  description: string;
  howItWorks: string;
  image: string;
  imageAlt: string;
  benefits: string[];
  faqs: ServiceFaq[];
  extraImages: string[];
  metaTitle: string;
  metaDescription: string;
};

export const SERVICES: Service[] = [
  {
    slug: "tratamento-unha-encravada-belem",
    title: "Tratamento de Unha Encravada em Belém do Pará",
    shortTitle: "Unha Encravada",
    
    excerpt: "Alívio imediato da dor com técnica especializada e segura.",
    description:
      "A onicocriptose (unha encravada) é uma das queixas mais comuns na clínica de podologia. Na Podomasso, em Belém do Pará, utilizamos técnicas modernas e indolores para remover a unha encravada com segurança, sem cortes profundos e com resultados imediatos.",
    howItWorks:
      "Nosso atendimento começa com uma assepsia rigorosa da área afetada. A podóloga Rosa Chagas realiza o desbastamento e a remoção da espícula (pedaço de unha que está encravado) utilizando instrumentos de precisão esterilizados em autoclave. O procedimento é focado no alívio imediato da pressão e da dor, seguido de um curativo antisséptico para garantir a cicatrização perfeita.",
    image: unhaImg,
    imageAlt: "Tratamento de unha encravada em Belém do Pará — Clínica Podomasso",
    benefits: [
      "Alívio da dor já na primeira sessão",
      "Técnica indolor e sem cortes profundos",
      "Acompanhamento até a recuperação total",
      "Orientação para evitar reincidência",
    ],
    faqs: [
      {
        q: "O tratamento de unha encravada dói?",
        a: "Apesar do receio inicial, nossa técnica é focada no conforto. O alívio da dor é quase instantâneo assim que a pressão é removida.",
      },
      {
        q: "Preciso de anestesia para o procedimento?",
        a: "Não. Como utilizamos técnicas de podologia avançada, o procedimento é muito bem tolerado e não exige anestesia injetável.",
      },
      {
        q: "Quanto tempo demora para cicatrizar?",
        a: "A cicatrização inicial ocorre em poucos dias, mas o alívio da dor é imediato. Orientamos todo o cuidado pós-procedimento.",
      },
      {
        q: "Como evitar que a unha encrave novamente?",
        a: "Durante a consulta, ensinamos o corte correto e, se necessário, indicamos o uso de órteses para correção do formato da unha.",
      },
    ],
    extraImages: [clinicaInterior, podologaImg],
    metaTitle: "Tratamento de Unha Encravada em Belém do Pará | Podomasso",
    metaDescription:
      "Tratamento de unha encravada em Belém do Pará com técnica indolor. Alívio imediato da dor com a podóloga Rosa Chagas. Agende sua avaliação na Podomasso.",
  },
  {
    slug: "remocao-calos-calosidades-belem",
    title: "Remoção de Calos e Calosidades em Belém do Pará",
    shortTitle: "Calos e Calosidades",
    
    excerpt: "Remoção profissional e segura, sem dor, com resultados imediatos.",
    description:
      "Calos e calosidades causam dor e desconforto ao caminhar. A remoção feita por podóloga profissional garante segurança, alívio imediato e evita complicações. Em nossa clínica de podologia em Belém, usamos equipamentos modernos para um procedimento rápido, indolor e definitivo.",
    howItWorks:
      "Iniciamos com uma avaliação biomecânica para entender o que está causando a pressão excessiva. O tratamento envolve o desbastamento profissional das camadas de pele morta e o uso de brocas específicas que suavizam a pele sem causar ferimentos. Finalizamos com uma hidratação profunda para restaurar a elasticidade da pele.",
    image: calosImg,
    imageAlt: "Remoção de calos e calosidades em Belém do Pará — Podomasso",
    benefits: [
      "Procedimento indolor com equipamento profissional",
      "Resultado visível na hora",
      "Orientação para prevenir o retorno",
      "Higiene e biossegurança hospitalar",
    ],
    faqs: [
      {
        q: "A remoção de calos é definitiva?",
        a: "A remoção remove o excesso de pele na hora, mas para ser definitivo é preciso corrigir a causa (calçado ou pisada), o que orientamos na consulta.",
      },
      {
        q: "Posso remover calos em casa?",
        a: "Não é recomendado. O uso de lâminas ou produtos químicos caseiros pode causar infecções e feridas graves, especialmente em diabéticos.",
      },
      {
        q: "O calo tem 'olho' ou raiz?",
        a: "Calos são acúmulos de queratina por pressão. O que muitos chamam de 'olho' pode ser uma verruga plantar, que exige tratamento diferente.",
      },
    ],
    extraImages: [clinicaRecepcao, clinicaInterior],
    metaTitle: "Remoção de Calos e Calosidades em Belém do Pará | Podomasso",
    metaDescription:
      "Remoção profissional de calos e calosidades em Belém do Pará. Procedimento indolor com a podóloga Rosa Chagas. Alívio imediato. Agende na Podomasso.",
  },
  {
    slug: "tratamento-pe-diabetico-belem",
    title: "Tratamento de Pé Diabético em Belém do Pará",
    shortTitle: "Pé Diabético",
    
    excerpt: "Protocolo preventivo completo para evitar complicações graves.",
    description:
      "O pé diabético exige cuidado especializado para evitar feridas, infecções e amputações. A Podomasso é referência em Belém do Pará no atendimento ao paciente diabético, com avaliação criteriosa, orientação contínua e protocolos de segurança rigorosos.",
    howItWorks:
      "Realizamos testes de sensibilidade (monofilamento) e avaliação da circulação. O corte das unhas e a remoção de peles são feitos com técnica de 'pés de seda', sem qualquer risco de cortes. O foco é a prevenção total e a detecção precoce de qualquer alteração que possa levar a úlceras.",
    image: diabImg,
    imageAlt: "Tratamento de pé diabético em Belém do Pará — Clínica Podomasso",
    benefits: [
      "Avaliação completa de sensibilidade",
      "Cuidado preventivo e terapêutico",
      "Orientações personalizadas para o dia a dia",
      "Acompanhamento mensal recomendado",
    ],
    faqs: [
      {
        q: "Por que o diabético precisa de podólogo?",
        a: "A perda de sensibilidade pode fazer com que pequenos machucados não sejam sentidos, evoluindo para infecções graves se não cuidados profissionalmente.",
      },
      {
        q: "Com que frequência o diabético deve vir à clínica?",
        a: "Recomendamos uma visita mensal preventiva para garantir que os pés estejam sempre saudáveis e sem riscos.",
      },
      {
        q: "Vocês tratam feridas abertas?",
        a: "Trabalhamos focados na prevenção. Se houver ferida complexa, fazemos a avaliação e o encaminhamento para a equipe multidisciplinar necessária.",
      },
    ],
    extraImages: [podologaImg, clinicaInterior],
    metaTitle: "Tratamento de Pé Diabético em Belém do Pará | Podomasso",
    metaDescription:
      "Tratamento especializado de pé diabético em Belém do Pará. Prevenção de feridas e complicações com a podóloga Rosa Chagas. Agende sua avaliação.",
  },
  {
    slug: "tratamento-micose-unhas-belem",
    title: "Tratamento de Micose nas Unhas em Belém do Pará",
    shortTitle: "Micoses e Fungos",
    
    excerpt: "Tratamento definitivo para onicomicose com acompanhamento completo.",
    description:
      "A onicomicose (micose nas unhas) é uma infecção fúngica persistente que exige tratamento profissional. Na Podomasso, em Belém do Pará, fazemos diagnóstico, desbastamento e tratamento contínuo, devolvendo a saúde e a estética das unhas.",
    howItWorks:
      "O tratamento consiste na limpeza técnica profunda da unha, removendo a parte morta e contaminada pelo fungo (desbastamento). Isso permite que os medicamentos antifúngicos (locais ou orais) penetrem melhor. Utilizamos equipamentos que agilizam a recuperação da unha saudável.",
    image: micoseImg,
    imageAlt: "Tratamento de micose nas unhas em Belém do Pará — Podomasso",
    benefits: [
      "Diagnóstico preciso da micose",
      "Desbastamento profissional da unha afetada",
      "Tratamento eficaz e contínuo",
      "Recuperação estética completa",
    ],
    faqs: [
      {
        q: "Quanto tempo dura o tratamento de micose?",
        a: "Fungos de unha são persistentes. O tratamento dura o tempo de crescimento de uma unha nova saudável, que pode levar de 6 a 12 meses.",
      },
      {
        q: "A micose pode passar de uma unha para outra?",
        a: "Sim, é contagioso. Por isso o tratamento deve ser iniciado o quanto antes e os cuidados com calçados e meias devem ser rigorosos.",
      },
      {
        q: "O tratamento dói?",
        a: "Não. O desbastamento da unha contaminada é indolor, pois removemos apenas o tecido que já está comprometido e sem sensibilidade.",
      },
    ],
    extraImages: [clinicaInterior, clinicaRecepcao],
    metaTitle: "Tratamento de Micose nas Unhas em Belém do Pará | Podomasso",
    metaDescription:
      "Tratamento de micose nas unhas (onicomicose) em Belém do Pará. Resultado definitivo com a podóloga Rosa Chagas. Agende avaliação na Podomasso.",
  },
  {
    slug: "hidratacao-pes-ressecados-belem",
    title: "Tratamento de Pés Ressecados e Rachados em Belém do Pará",
    shortTitle: "Pés Ressecados",
    
    excerpt: "Hidratação profunda e tratamento de fissuras dolorosas.",
    description:
      "Pés ressecados e com rachaduras são porta de entrada para infecções. Nosso tratamento de hidratação profunda em Belém do Pará alia esfoliação, ativos profissionais e orientação para devolver a maciez e prevenir fissuras.",
    howItWorks:
      "Iniciamos com um escalda-pés relaxante seguido de esfoliação para remover células mortas. Aplicamos cremes com ureia e ativos de alta penetração, utilizando técnicas de oclusão para garantir que a hidratação chegue às camadas mais profundas da pele.",
    image: hidratImg,
    imageAlt: "Hidratação de pés ressecados em Belém do Pará — Podomasso",
    benefits: [
      "Esfoliação profissional",
      "Hidratação com ativos de alta performance",
      "Tratamento de fissuras dolorosas",
      "Maciez visível em uma sessão",
    ],
    faqs: [
      {
        q: "Por que meus pés racham tanto?",
        a: "Pode ser por falta de hidratação, uso de sandálias abertas, excesso de peso ou modo de caminhar. Analisamos cada caso na consulta.",
      },
      {
        q: "Rachaduras podem causar infecção?",
        a: "Sim, fissuras profundas são portas abertas para bactérias e fungos, podendo causar inflamações dolorosas e graves.",
      },
      {
        q: "Creme comum resolve o problema?",
        a: "Cremes de mercado ajudam a manter, mas para tratar rachaduras já instaladas são necessários ativos em concentrações profissionais.",
      },
    ],
    extraImages: [clinicaRecepcao, podologaImg],
    metaTitle: "Tratamento de Pés Ressecados em Belém do Pará | Podomasso",
    metaDescription:
      "Hidratação profunda para pés ressecados e rachados em Belém do Pará. Tratamento profissional na Podomasso com a podóloga Rosa Chagas.",
  },
  {
    slug: "massagem-terapeutica-pes-belem",
    title: "Massagem Terapêutica nos Pés em Belém do Pará",
    shortTitle: "Massagem Terapêutica",
    
    excerpt: "Relaxamento profundo, melhora da circulação e alívio de dores.",
    description:
      "A massagem terapêutica nos pés alivia tensões, melhora a circulação sanguínea e proporciona bem-estar. Disponível como complemento aos tratamentos podológicos ou como sessão individual, em ambiente acolhedor da nossa clínica em Belém.",
    howItWorks:
      "Utilizamos técnicas de reflexologia e drenagem podal em um ambiente climatizado e com música relaxante. A massagem foca nos pontos de maior tensão, promovendo o relaxamento muscular e auxiliando na redução de inchaços (edemas) nos pés e tornozelos.",
    image: massagemImg,
    imageAlt: "Massagem terapêutica nos pés em Belém do Pará — Podomasso",
    benefits: [
      "Alívio de dores e tensões",
      "Melhora da circulação sanguínea",
      "Relaxamento profundo",
      "Bem-estar imediato",
    ],
    faqs: [
      {
        q: "Quanto tempo dura uma sessão?",
        a: "As sessões individuais duram em média 30 a 40 minutos. Quando combinadas com outros tratamentos, podem durar 15 a 20 minutos.",
      },
      {
        q: "Qualquer pessoa pode fazer?",
        a: "Sim, mas fazemos uma breve avaliação para casos de trombose recente ou processos inflamatórios agudos onde a massagem possa ser contraindicada.",
      },
      {
        q: "Ajuda no inchaço dos pés?",
        a: "Muito! As manobras auxiliam no retorno venoso e na drenagem linfática, sendo excelente para quem passa muito tempo em pé.",
      },
    ],
    extraImages: [clinicaInterior, podologaImg],
    metaTitle: "Massagem Terapêutica nos Pés em Belém do Pará | Podomasso",
    metaDescription:
      "Massagem terapêutica nos pés em Belém do Pará. Relaxamento, melhora da circulação e alívio de dores na Clínica Podomasso. Agende já.",
  },
  {
    slug: "ortese-correcao-unhas-belem",
    title: "Órtese e Correção de Unhas em Belém do Pará",
    shortTitle: "Órtese / Correção",
    
    excerpt: "Correção de unhas curvadas sem cirurgia — como aparelho ortodôntico.",
    description:
      "A órtese ungueal é um pequeno dispositivo que corrige unhas curvadas, encravadas ou deformadas, sem necessidade de cirurgia. Funciona como um aparelho ortodôntico para a unha, com resultados graduais e definitivos.",
    howItWorks:
      "Fixamos uma pequena lâmina metálica ou de fibra de memória molecular sobre a superfície da unha. Esse dispositivo exerce uma força de tração constante e suave, forçando a unha a crescer no formato correto, abrindo a curvatura e evitando que ela encrave.",
    image: orteseImg,
    imageAlt: "Órtese e correção de unhas em Belém do Pará — Podomasso",
    benefits: [
      "Sem cirurgia, sem cortes",
      "Correção definitiva e gradual",
      "Indolor e discreto no dia a dia",
      "Indicado para unhas curvadas e encravadas",
    ],
    faqs: [
      {
        q: "A órtese incomoda ou machuca?",
        a: "Não. Depois de colocada, você mal percebe que está usando. Ela é plana e fica rente à unha, permitindo o uso de calçados normalmente.",
      },
      {
        q: "Quanto tempo preciso usar a órtese?",
        a: "Depende de cada caso, mas geralmente são necessários de 3 a 6 meses para que a unha memorize o novo formato.",
      },
      {
        q: "Posso pintar a unha com a órtese?",
        a: "Sim, você pode passar esmalte por cima de alguns tipos de órtese sem comprometer o resultado do tratamento.",
      },
    ],
    extraImages: [podologaImg, clinicaInterior],
    metaTitle: "Órtese para Correção de Unhas em Belém do Pará | Podomasso",
    metaDescription:
      "Órtese ungueal para correção de unhas em Belém do Pará. Solução sem cirurgia para unhas curvadas e encravadas. Agende na Podomasso.",
  },
  {
    slug: "verrugas-plantares-belem",
    title: "Tratamento de Verrugas Plantares (Olho de Peixe) em Belém do Pará",
    shortTitle: "Verrugas Plantares",
    
    excerpt: "Eliminação do olho de peixe com técnicas modernas e eficazes.",
    description:
      "As verrugas plantares (olho de peixe) são causadas por vírus e provocam dor ao caminhar. Na Podomasso, em Belém do Pará, fazemos o tratamento com técnicas modernas, eficazes e seguras, com acompanhamento até a eliminação completa.",
    howItWorks:
      "O tratamento foca na cauterização controlada da lesão. Utilizamos ácidos específicos de uso profissional e desbastamento técnico para remover as camadas da verruga sem atingir o tecido saudável ao redor, garantindo que o vírus seja eliminado.",
    image: verrugaImg,
    imageAlt: "Tratamento de verrugas plantares em Belém do Pará — Podomasso",
    benefits: [
      "Tratamento eficaz e moderno",
      "Acompanhamento até a cura",
      "Eliminação da dor ao caminhar",
      "Orientação para evitar contágio",
    ],
    faqs: [
      {
        q: "O 'olho de peixe' é contagioso?",
        a: "Sim, é causado pelo vírus HPV. Pode ser transmitido pelo contato direto ou por superfícies úmidas como bordas de piscinas e chuveiros públicos.",
      },
      {
        q: "Quantas sessões são necessárias?",
        a: "Depende do tamanho e da profundidade da lesão. Geralmente de 3 a 5 sessões são suficientes para a eliminação total.",
      },
      {
        q: "Fica cicatriz após o tratamento?",
        a: "Se feito corretamente por profissional, a pele se regenera totalmente sem deixar cicatrizes aparentes.",
      },
    ],
    extraImages: [clinicaInterior, podologaImg],
    metaTitle: "Tratamento de Verrugas Plantares em Belém do Pará | Podomasso",
    metaDescription:
      "Tratamento de verrugas plantares (olho de peixe) em Belém do Pará. Técnica moderna e eficaz na Clínica Podomasso. Agende sua consulta.",
  },
];

export const FAQS = [
  {
    q: "Como funciona a consulta com a podóloga em Belém do Pará?",
    a: "A consulta começa com avaliação completa dos pés e histórico do paciente. A podóloga Rosa Chagas identifica o problema, explica o tratamento indicado e realiza o procedimento na mesma sessão sempre que possível. Tudo com biossegurança rigorosa.",
  },
  {
    q: "Os tratamentos de podologia são dolorosos?",
    a: "Não. Utilizamos técnicas modernas e equipamentos profissionais que tornam os procedimentos confortáveis e indolores. Mesmo o tratamento de unha encravada, que parece assustador, é feito com alívio imediato da dor.",
  },
  {
    q: "Qual a diferença entre pedicure e podologia?",
    a: "A pedicure é um serviço estético. A podologia é uma área da saúde, voltada ao tratamento e prevenção de doenças dos pés. A podóloga tem formação técnica/superior e registro profissional (CR), como Rosa Chagas — CR8M 00017.",
  },
  {
    q: "Quem deve procurar uma podóloga em Belém do Pará?",
    a: "Qualquer pessoa com dor, calos, unhas encravadas, micoses, rachaduras ou que tenha diabetes. Também é indicado para gestantes, idosos, atletas e quem quer cuidados preventivos.",
  },
  {
    q: "Com que frequência devo ir à podóloga?",
    a: "O ideal é a cada 30 a 45 dias para manutenção preventiva. Pacientes com diabetes ou problemas crônicos devem manter consultas mensais regulares.",
  },
  {
    q: "A clínica atende por convênio médico?",
    a: "No momento realizamos apenas atendimentos particulares. No entanto, emitimos nota fiscal detalhada que pode ser utilizada para solicitação de reembolso junto ao seu plano de saúde, dependendo da sua cobertura.",
  },
  {
    q: "Quais as formas de pagamento aceitas?",
    a: "Aceitamos pagamentos via PIX, cartões de crédito e débito (todas as bandeiras) e dinheiro. Parcelamos tratamentos de longa duração, como órteses e micoses, consulte nossas condições.",
  },
  {
    q: "Como posso agendar uma avaliação na Podomasso?",
    a: "É simples: clique no botão de WhatsApp em qualquer página do site, preencha o formulário de agendamento, ou ligue para (91) 8022-5829. Atendemos de domingo a sexta, das 9h às 20h.",
  },
];
